<template>
  <div :class="['filter-selection-overview', {hide: filterHiddenOnMobile}]">
    <div class="selection-label" v-html="$t('productOverview.yourSelection')"/>
    <ul>
      <li v-for="entity in entities" :key="entity.id">
        <a :id="'filter-selection-item-'+entity.id" href="#" @click.prevent="$emit('entityClicked', entity)">
          {{ entity.title }}
        </a>
      </li>
    </ul>
    <a v-if="includeClearAllButton && entities.length > 0"
       href="javascript:void(0)"
       class="button clear-selection"
       @click.prevent="$emit('clearAllClicked')">
      {{ $t('productOverview.clearSelection') }}
    </a>
  </div>
</template>
<script>
export default {
  name: 'FilterChipBar',
  props: {
    filterHiddenOnMobile: {
      type: Boolean,
      default: false
    },
    entities: {
      type: Array,
      default: () => []
    },
    includeClearAllButton: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FilterChipBar.vue